var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"testwrap"},_vm._l((_vm.list),function(item,index){return _c('img',{key:index,attrs:{"src":item,"alt":""}})}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }